import { Container, Graphics, Point, Rectangle, Sprite, utils } from 'pixi.js'
import { gsap } from 'gsap'
// import ItemBullet from './ItemBullet'
import { dimensions, debugMode, ITEMS_PHASE2_ONLY } from '../../config/settings'
import { IItem } from '../../data/types'
import { animation } from '../../config/settings'
import { GlobalState } from '../../config/globalState'

export default class Item extends Container {
  public readonly id: string
  public readonly activity: any
  public readonly itemBullet: any // ItemBullet - commented out

  private readonly center: Point
  private readonly hitRect: Rectangle

  private normalSprite?: Sprite
  private hoverSprite: Sprite
  private isHovered = false

  constructor(positionInfo: IItem, activity: any) {
    super()
    this.id = positionInfo.id
    this.activity = activity

    // Bullet - commented out, not showing bullets
    // this.itemBullet = new ItemBullet(
    //   new Point(positionInfo.hint.x, positionInfo.hint.y),
    //   activity.title.replace(/\n/g, ' '),
    //   activity.day,
    //   dimensions.SCENE_WIDTH,
    //   // style.item.bullet,
    // )
    // Create dummy bullet object to avoid errors when code references it
    this.itemBullet = {
      setHoverState: () => {},
      displayBullet: () => {},
      getBulletCenterGlobal: () => new Point(0, 0),
      visible: false,
    } as any

    // Tweak the positions, not sure why some items are not correctly positioned (in PSD they are)
    // if (positionInfo.id === 'hotel') {
    //   positionInfo.x -= 3
    // }

    // if (positionInfo.id === 'vecirek') {
    //   positionInfo.x -= 3
    // }

    // Position & hit area
    this.position.set(Math.round(positionInfo.x), Math.round(positionInfo.y))
    this.hitRect = new Rectangle(
      positionInfo.hit.x - positionInfo.x,
      positionInfo.hit.y - positionInfo.y,
      positionInfo.hit.w,
      positionInfo.hit.h,
    )
    this.hitArea = this.hitRect
    this.center = new Point(positionInfo.hit.x + positionInfo.hit.w / 2, positionInfo.hit.y + positionInfo.hit.h / 2)
    // if (positionInfo.beak) {
    //   this.beak = new Point(positionInfo.beak.x, positionInfo.beak.y)
    // }

    // Sprites
    const isPhase2Only = ITEMS_PHASE2_ONLY.includes(this.id)

    this.hoverSprite = Sprite.from(`${this.id}_2.png`)
    // For phase 2 only items, hide phase 2 by default (it's part of background)
    // Phase 2 will only show on hover
    this.hoverSprite.visible = false
    this.addChild(this.hoverSprite)

    // Only load phase 1 if item is not in the phase 2 only list
    if (!isPhase2Only) {
      const { numFrames } = GlobalState.itemsConfig[this.activity.positionId]
      if (numFrames > 1) {
        this.normalSprite = Sprite.from(`${this.id}_1.png`)
        this.addChild(this.normalSprite)
      }
    }

    // Interaction setup
    this.visible = false
    this.alpha = 0
    this.eventMode = 'passive'
    this.zIndex = 3

    if (debugMode) this.drawDebugHitArea()
  }

  public show(visible: boolean, instant = false): void {
    if (this.visible === visible) return

    this.eventMode = visible ? 'static' : 'passive'
    gsap.killTweensOf(this)

    if (visible) this.visible = true

    gsap.to(this, {
      duration: instant ? 0 : animation.SHOW_TWEEN_DURATION,
      alpha: visible ? 1 : 0,
      onComplete: () => {
        this.visible = visible
      },
    })
  }

  public setHoverState(hover: boolean): void {
    const canvasContainer = document.querySelector('.canvas-container')
    const cursorClass = this.id === 'bratrstvo' ? 'cursor-paw' : 'cursor-hand'
    const isPhase2Only = ITEMS_PHASE2_ONLY.includes(this.id)

    if (canvasContainer) {
      if (hover) {
        canvasContainer.classList.add(cursorClass)
      } else {
        canvasContainer.classList.remove(cursorClass)
      }
    }

    if (hover === this.isHovered) return
    this.isHovered = hover

    // For phase 2 only items: show phase 2 on hover, hide when not hovering
    // (no phase 1 sprite exists, background already has the default state)
    if (isPhase2Only) {
      this.hoverSprite.visible = hover
    } else {
      this.hoverSprite.visible = hover
      if (this.normalSprite) this.normalSprite.visible = !hover
    }
  }

  public getCenterPosition(): Point {
    return this.center
  }

  // public getBeakPosition(): Point {
  //   return this.beak ? this.beak.clone() : this.getCenterPosition()
  // }

  private drawDebugHitArea(): void {
    const g = new Graphics()
    g.beginFill(utils.string2hex('0xFFFF00'), 0.4)
    g.drawRect(this.hitRect.x, this.hitRect.y, this.hitRect.width, this.hitRect.height)
    g.endFill()

    // top-left marker
    g.beginFill(utils.string2hex('0xFF0000'), 0.4)
    g.drawCircle(this.hitRect.x, this.hitRect.y, 5)
    g.endFill()

    // center marker
    g.beginFill(utils.string2hex('0xFF0000'), 0.4)
    g.drawCircle(this.center.x - this.x, this.center.y - this.y, 5)
    g.endFill()

    this.addChild(g)
  }
}
